import React, { useEffect, useState } from "react";
import "./SportRadarMatchOdds.scss";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";

type pageProps = {
  data: any;
  selectedbet: string;
  mainValue?: any;
  marketId: string;
};

const OddsGrid: React.FC<pageProps> = (props) => {
  const { data, selectedbet, mainValue, marketId } = props;
  const [classes, setClasses] = useState<string>("odds");

  const [oddAnimation, setOddAnimation] = useState<string>("");
  const [currentValue, setCurrentValue] = useState<number>(null);
  const [timer, setTimer] = useState(null);

  useEffect(() => oddValueChanged(), [mainValue]);

  const oddValueChanged = () => {
    clearTimeout(timer);
    const chVal = mainValue;
    if (chVal) {
      const cVal = currentValue;
      setCurrentValue(chVal);
      let showAnimation = true;
      if (showAnimation) {
        if (cVal && chVal !== cVal) {
          if (cVal < chVal) {
            setClasses(classes + " odd-change");
            setOddAnimation("fa fa-arrow-up");
            setTimer(
              setTimeout(() => {
                setClasses(classes.replace(" odd-change", ""));
                setOddAnimation("");
              }, 3000)
            );
          }
          if (cVal > chVal) {
            setClasses(classes + " odd-change1");
            setOddAnimation("fa fa-arrow-down");

            setTimer(
              setTimeout(() => {
                setClasses(classes.replace(" odd-change1", ""));
                setOddAnimation("");
              }, 3000)
            );
          }
          // if (!classes.includes('odd-change'))
          //     setClasses(classes + ' odd-change');
          // setTimer(
          //     setTimeout(
          //         () => setClasses(classes.replace(' odd-change', '')),
          //         5000
          //     )
          // );
        }
      }
    }
  };

  return (
    <>
      <div
        className={
          selectedbet === data?.runnerId + data?.runnerName + marketId
            ? "active-runner-paper"
            : "runner-paper"
        }
      >
        <div className="runner">{data?.runnerName}</div>
        <div className={classes}>
          {Number(mainValue).toFixed(2)}{" "}
          <div className="arrow bounce">
            <a className={oddAnimation}></a>
          </div>
        </div>
      </div>
    </>
  );
};

export default OddsGrid;
